module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBlack.29e591b.woff";